import { day, isAfter } from '~/astra'

import { IncidentOrMaintenanceStatusReport, IncidentStatusReport, MaintenanceStatusReport, StatusUpdate, UnresolvedAggregateState } from './schema'

export type BaseStatusData = {
    title: string
    latestUpdateMessage: string | undefined
    latestUpdateTimestamp: string | undefined
}

export type Incident = BaseStatusData & {
    aggregateState: UnresolvedAggregateState
}

export type Maintenance = BaseStatusData & {
    reportId: string
    latestUpdateId: string | undefined
    startsAt: string
    endsAt: string
}

export type StatusPageData = {
    incident: Incident | null
    maintenance: Maintenance | null
}

export const shouldReplaceLatestReport = (statusReport: IncidentOrMaintenanceStatusReport, latestReport: IncidentOrMaintenanceStatusReport | null) =>
    !latestReport || isAfter(day(statusReport.attributes.starts_at), day(latestReport.attributes.starts_at))

const getLatestUpdate = (statusReport: IncidentOrMaintenanceStatusReport, statusUpdateById: Map<string, StatusUpdate>): StatusUpdate | undefined => {
    let latestUpdate: StatusUpdate | undefined

    for (const { id } of statusReport.relationships.status_updates.data) {
        const update = statusUpdateById.get(id)

        if (!update) continue

        if (!latestUpdate || isAfter(day(update.attributes.published_at), day(latestUpdate.attributes.published_at))) {
            latestUpdate = update
        }
    }

    return latestUpdate
}

export function getReportData(statusReport: IncidentStatusReport | null, statusUpdateById: Map<string, StatusUpdate>): Incident | null
export function getReportData(statusReport: MaintenanceStatusReport | null, statusUpdateById: Map<string, StatusUpdate>): Maintenance | null
export function getReportData(
    statusReport: IncidentOrMaintenanceStatusReport | null,
    statusUpdateById: Map<string, StatusUpdate>
): Incident | Maintenance | null {
    if (!statusReport) return null

    const latestUpdate = getLatestUpdate(statusReport, statusUpdateById)

    const base = {
        title: statusReport.attributes.title,
        latestUpdateMessage: latestUpdate?.attributes.message,
        latestUpdateTimestamp: latestUpdate?.attributes.published_at,
    }

    if (statusReport.attributes.report_type === 'maintenance') {
        return {
            ...base,
            reportId: statusReport.id,
            latestUpdateId: latestUpdate?.id,
            startsAt: statusReport.attributes.starts_at,
            endsAt: statusReport.attributes.ends_at,
        }
    } else {
        return { ...base, aggregateState: statusReport.attributes.aggregate_state }
    }
}
